import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-integration-rule-list",
  "use": "icon-integration-rule-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-integration-rule-list\"><defs><style type=\"text/css\"></style></defs><path d=\"M200 200h624c22.1 0 40 17.9 40 40v544c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V240c0-22.1 17.9-40 40-40z\" fill=\"#409EFF\" p-id=\"7987\" /><path d=\"M240 280h544v64H240zM240 400h544v64H240zM240 520h544v64H240zM240 640h544v64H240z\" fill=\"white\" p-id=\"7988\" /><circle cx=\"280\" cy=\"312\" r=\"12\" fill=\"#409EFF\" p-id=\"7989\" /><circle cx=\"280\" cy=\"432\" r=\"12\" fill=\"#409EFF\" p-id=\"7990\" /><circle cx=\"280\" cy=\"552\" r=\"12\" fill=\"#409EFF\" p-id=\"7991\" /><circle cx=\"280\" cy=\"672\" r=\"12\" fill=\"#409EFF\" p-id=\"7992\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/integration-rule-list.svg
// module id = zd1e
// module chunks = 100